import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useStore } from 'effector-react';
import { ImageType } from '@types';
import useEditingStore from '@hooks/useEditingStore';
import {
  $categoryList,
  $categoryMap,
  $curScene,
  $tourData,
} from '@stores/dataStores';
import { $editingCategoryConfig, $editingFlag } from '@stores/editingStores';
import Image from '@components/Image';
import { $GateCategoryHeight } from '@stores/uiStores';

const Group = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  color: #fff;
`;

export function WInfoButtonsMa() {
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const categoryConfig = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.categoryConfig,
    $editing: $editingCategoryConfig.store,
  });
  const scene = useStore($curScene);
  const categoryList = useStore($categoryList);
  const categoryMap = useStore($categoryMap);
  const height = useStore($GateCategoryHeight.state);

  const count = useMemo(() => {
    let sum = 0;
    let index = 0;
    const fn = (cateIds: number[]) => {
      for (let i = 0; i < cateIds.length; i++) {
        const item = categoryMap.get(cateIds[i]);
        if (item) {
          const { categoryIds, sceneIds } = item;
          if (categoryIds.length) {
            fn(categoryIds);
          } else if (sceneIds.length) {
            const sceneIndex = sceneIds.indexOf(scene?.id!);
            if (sceneIndex > -1) index = sum + sceneIndex + 1;
            sum += sceneIds.length;
          }
        }
      }
    };
    fn(categoryList);
    return `${index}/${sum}`;
  }, [scene, categoryMap, categoryList]);

  const showShare = !!(flag?.showShareBtn ?? 1);
  const showLike = !!(flag?.showLikeBtn ?? 1);
  const showCommentBtn = !!(flag?.showCommentBtnV2 ?? 1);
  const showCategoryButton = !!categoryConfig?.enabledButton;

  return (
    <div
      className="absolute flex items-center"
      style={{ bottom: height ? height + 65 : 40 }}
    >
      {showCategoryButton && (
        <Group className="w-40 justify-center">
          <Image
            src="/imgs/ib-list.8a7b3ee09c56c57fb16cd6b2ac31fa10.png"
            type={ImageType.sysMedia}
            style={{ width: 24, height: 24 }}
          />
          <div
            className="absolute"
            style={{ fontSize: 7, lineHeight: '7px', top: 9, left: 20 }}
          >
            {count}
          </div>
        </Group>
      )}
      <Group className="ml-15 w-230" style={{ padding: '0 12px' }}>
        <Image
          src="/imgs/ib-left.399c3ef4ee054edf2d458dff8e4eddee.png"
          type={ImageType.sysMedia}
          style={{ width: 17, height: 17 }}
        />
        <Image
          src="/imgs/ib-pause.1588c71e7fffaa4573606a666d54fad0.png"
          type={ImageType.sysMedia}
          className="ml-30 h-16 w-16"
        />
        <div className="ml-5 grow truncate text-sm">{scene?.name ?? ''}</div>
        <Image
          src="/imgs/ib-right.919a60c45d9c4b686c6e859145df1c55.png"
          type={ImageType.sysMedia}
          className="ml-30"
          style={{ width: 17, height: 17 }}
        />
      </Group>
      <Group className="ml-15 w-40 justify-center">
        <Image
          src="/imgs/ib-sound.c2669fb0329f059783f71ef434aab98e.png"
          type={ImageType.sysMedia}
          style={{ width: 24, height: 24 }}
        />
      </Group>
      {(showShare || showLike || showCommentBtn) && (
        <Group className="ml-15 justify-center px-2">
          {showLike && (
            <Image
              src="/imgs/ib-like.b303242bc619866f1132aaa2540a9640.png"
              type={ImageType.sysMedia}
              style={{ width: 20.5, height: 20.5, margin: '0 8px' }}
            />
          )}
          {showCommentBtn && (
            <Image
              src="/imgs/ib-comment.908da781de9161eb61e62a89a8ad8d77.png"
              type={ImageType.sysMedia}
              style={{ width: 20, height: 20, margin: '0 8px' }}
            />
          )}
          {showShare && (
            <Image
              src="/imgs/ib-share.18a4f9b4b360950730b7fa6fcb9cc4f6.png"
              type={ImageType.sysMedia}
              style={{ width: 20, height: 20.5, margin: '0 8px' }}
            />
          )}
        </Group>
      )}
    </div>
  );
}
